import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { LanguageGetAllService } from '../../services';

export const fetchLanguageGetAll = createAsyncThunk(
    'languageGetAll/fetchLanguageGetAll',
    async () => {
        const response = await LanguageGetAllService()
        return response.result;
    }
);

const languageGetAllSlice = createSlice({
    name: 'languageGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLanguageGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLanguageGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchLanguageGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default languageGetAllSlice.reducer;
